import Link from 'next/link';
import clsx from 'clsx';
import { addCanalPlusGTMClass, formatCategoryUrl } from '../../services/lib/util';

export const Categories = ({ categories }) => {
  const dataSource = categories?.edges ?? categories?.nodes;

  if (!Array.isArray(dataSource) || dataSource.length === 0) {
    return null;
  }

  return (
    <div className="categories inline-flex flex-wrap px-0">
      {dataSource.map((category, index, array) => {
        const categoryItem = category?.node ?? category;
        const uri = categoryItem?.uri;
        const name = categoryItem?.name;

        if (!uri || !name) return null;

        const isLastElement = index === array.length - 1;

        return (
          <Link
            key={categoryItem?.id || uri || index}
            href={formatCategoryUrl(uri)}
            className={clsx(
              'category px-0 text-[12px] font-semibold leading-[16px] text-tertiary no-underline hover:underline',
              addCanalPlusGTMClass(uri),
            )}
          >
            {name}
            {!isLastElement && <>,&nbsp;</>}
          </Link>
        );
      })}
    </div>
  );
};
